import React from 'react';
import FindPwForm from '../../components/Authentication/FindPw';

const FindPwPage: React.FC = () => {
  return (
    <>
      <FindPwForm />
    </>
  );
};

export default FindPwPage;
